<template>
  <div id="update-customer-popup" v-if="isLoaded" style="background: #fff;">
    <!-- <div class="header" slot="header">
      <div class="mt-6 flex items-center justify-between px-6">
        <h2 class="m-auto">UPDATE CUSTOMER</h2>
      </div>
      <vs-divider class="mt-4 pt-3"></vs-divider>
    </div>-->

    <!-- <VuePerfectScrollbar class="scroll-area--data-list-add-new sidebar-content p-6" style="max-height: calc(100vh - 482px)"> -->
    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new update-customer-content sidebar-content p-6 px-2"
    >
      <div class="sidebar-content scroll">
        <div class="sm:flex justify-between my-3">
          <div class="flex">
            <vs-avatar
              size="large"
              :text="StringHelper.changeFormatAvatar(v_full_name)"
              class="m-0 text-2xl customer-avatar"
            />
            <div class="flex flex-col ml-4 justify-center">
              <span class="font-bold text-2xl break-word">{{ v_full_name }}</span>
              <span>
                Since
                <span>{{ changeFormat(create_at) }}</span>
              </span>
            </div>
          </div>
          <div class="flex flex-col justify-center mr-base pr-base">
            <span class="font-bold">
              Current point:
              <span
                class="text-lg text-primary"
              >{{current_point ? current_point : 0}} pts</span>
            </span>
          </div>
        </div>

        <div class="flex align-center mb-4">
          Add/remove from current pts:
          <vs-input-number class="ml-6" v-model="number0" :step="1" :min="min" :max="max" />
        </div>

        <p class="mb-4">
          <span>
            Total visit:
            <span class="font-bold text-lg">{{visit_count}}</span>
          </span>
          <span class="ml-base pl-6">
            Lifetime point:
            <span class="font-bold text-lg">{{lifetime_point ? lifetime_point : 0}}</span>
          </span>
        </p>

        <p class="mb-4" v-if="source">
          Source: <span class="font-bold">{{ source }}</span>
        </p>

        <div class="info-form">
          <vs-input
            label="Full name"
            :maxlength="30"
            v-validate="{required: true, regex: '^[a-zA-Z0-9 ]+$'}"
            name="full_name"
            v-model="full_name"
            class="w-full"
            :danger="errors.has('full_name')"
            :danger-text="StringHelper.getErrorName(errors.first('full_name'), 'full_name')"
          />

          <vs-input label="Phone" v-model="phone" disabled="true" class="w-full" />

          <vs-input
            v-if="!has_err_email"
            v-validate="'email'"
            name="email"
            label="Email"
            :maxlength="30"
            v-model="email"
            class="w-full"
            :danger="errors.has('email')"
            danger-text="Please enter a valid email"
            @input="has_err_email = false"
            v-on:keypress="StringHelper.validateEmailChar($event, email)"
          />
          <vs-input
            v-else
            v-validate="'email'"
            name="email"
            label="Email"
            :maxlength="30"
            v-model="email"
            class="w-full"
            :danger="has_err_email"
            :danger-text="`${error_message_email}`"
            @input="has_err_email = false"
            v-on:keypress="StringHelper.validateEmailChar($event, email)"
          />

          <div class="mb-4">
            <label class="vs-input--label">Birthday</label>
            <br />
            <!-- <vs-row>
            <div class="flex mt-4 w-full">
              <v-select v-model="month" :options="months" class="w-1/2"></v-select>
              <v-select v-model="day" :options="days" class="sm:ml-4 w-1/2"></v-select>
            </div>
            </vs-row>-->
            <datepicker
              :use-utc="true"
              v-model="birthday"
              minimumView="day"
              maximumView="month"
              :format="birth_day_type"
            ></datepicker>
          </div>

          <label class="vs-input--label">Note</label>
          <vs-textarea
            :maxlength="1024"
            v-model="note"
            id="customer_note_textarea"
            class="my-4"
            @focus="setAutoHeight('customer_note_textarea')"
          />

          <vs-checkbox v-model="is_send_sms" class="m-0 p-0">Is send sms</vs-checkbox>
          <vs-checkbox v-if="show_option_block_booking" v-model="is_blocked_from_booking" class="m-0 p-0">Block from booking online</vs-checkbox>
        </div>
      </div>
    </VuePerfectScrollbar>

    <vs-divider class="mt-0"></vs-divider>
    <div class="vx-row justify-center my-3" slot="footer">
      <vs-button color="primary" class="text-white" @click="saveUpdate" :disabled="halfShow || isFromReview || isFromStaffRating">Save</vs-button>
      <vs-button type="border" color="danger" class="text-danger" @click="closePopup">Cancel</vs-button>
      <!-- <vs-button type="border" color="danger" class="text-danger" @click="popupActive=true">Delete</vs-button> -->
    </div>

    <!-- <vs-popup class="holamundo delete-customer" title="Delete Staff" :active.sync="popupActive">
      <div class="text-center">
          <h3>Do you want to delete this customer?</h3>
          <div class="flex flex-wrap justify-center align-center p-6 mt-6">
          <vs-button class="mr-6 align-center" @click="deleteCustomer">Delete</vs-button>
          <vs-button type="border" color="danger" @click.stop="closePopupDelete">Cancel</vs-button>
          </div>
      </div>
    </vs-popup>-->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import { StringHelper } from "../../models/string_helper";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import {
  changeFormatWithDateTime,
  formatBirthdayString,
} from "../../helper/datetimeHelper";
// import { buildLocale } from '@fullcalendar/core/datelib/locale';

export default {
  name: "vs-update-customer",
  components: {
    // SideBarItem: () => import("../../components/SideBarItem.vue"),
    "v-select": vSelect,
    VuePerfectScrollbar,
    Datepicker,
  },
  props: {
    activeCustomer: {
      type: Object,
      required: true,
    },
    // pageInfo: {
    //   type: Object,
    //   required: true
    // }
    currentPage: {
      type: Number,
      default: 1,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    search: {
      type: String,
    },
    filter: {
      type: Object,
    },
    isFromCheckout: {
      type: Boolean,
      default: false,
    },
    checkoutFilter: {
      type: Object,
      default: null
    },
    isPasscodeApprove: {
      type: Boolean,
      default: false,
    },
    isFromStaffRating: {
      type: Boolean,
      default: false
    },
    isFromReview: {
      type: Boolean,
      default: false
    },
    isFromCalling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const obj = {
      id: this.activeCustomer.id,
    };

    let isLoaded = false;
    let temp = {};
    let min = 0;
    let max = 999;
    let v_full_name = "";
    // let select = [];
    // let selectTemp = [];
    // let selected = [];
    let date = "";
    let loaded_data_num = 0;
    this.$store.dispatch("customerList/GET_A_CUSTOMER", obj).then(() => {
      this.loaded_data_num++;
      this.isLoaded = true;
      this.temp = JSON.parse(
        JSON.stringify(this.$store.getters["customerList/customerInfo"])
      );
      this.v_full_name = this.temp.full_name;
      this.min = -this.temp.current_point;
      // this.max = this.temp.current_point;
      this.date = this.temp.birthday;
      // console.log(this.temp)
      // for(let i = 0; i < this.temp.groups.length; i++) {
      //   this.select.push(this.temp.groups[i].group_id);
      //   this.selectTemp.push(this.temp.groups[i].group_id);
      //   this.selected.push(this.temp.groups[i].group_id)
      // }
      // this.select = this.temp.customer_groups
    });
    let options = [];
    // this.$store.dispatch("customerList/GET_GROUP_LIST").then((response) => {
    //   for(let i = 0;i<this.groupList.length;i++){
    //     // this.options.push(this.groupList[i].name)
    //     this.options.push({id:this.groupList[i].id,name: this.groupList[i].name})
    //   }
    //   // this.options = this.groupList
    // })
    let birth_day_type = formatBirthdayString();

    return {
      maxlength: 30,
      number0: 0,
      // months: [],
      // days: [],
      // select_month: 'Select month',
      // select_day: 'Select day',
      isLoaded,
      temp,
      // selectTemp,
      min,
      max,
      popupActive: false,
      // select: [],
      // select,
      options,
      // selected,
      v_full_name,
      StringHelper,
      date,
      isOpenLoading: false,
      loaded_data_num,
      birth_day_type,
      utc_birth: false,
      has_change_birthday: false,
      has_err_email: false,
      error_message_email: "",
      halfShow: true,
      // disabledDates: {
      //   to: new Date(new Date().getFullYear() + 100, 12, 30), // Disable all dates up to specific date
      //   from: new Date(new Date().getFullYear() + 1, 1, 1), // Disable all dates after specific date
      // }
      // options:[
      //   {
      //     // title:'Figures',
      //     group:[
      //       {text: 'Romboid', value: 4},
      //       {text: 'Trapeze', value: 5},
      //       {text: 'Triangle', value: 6},
      //       {text: 'Polygon', value: 7},
      //     ]
      //   },
      // ],
      // options: [
      //   {
      //     group: this.groupList
      //   }
      // ]
    };
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if (this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      },
    },
    isPasscodeApprove: {
      immediate: true,
      handler(newVal) {
        if (newVal == true) {
          this.halfShow = false;
        }
      },
    },
  },
  methods: {
    getUtc() {
      let date = new Date();
      if (date.getTimezoneOffset() < 0) {
        this.utc_birth = true;
      } else {
        this.utc_birth = false;
      }
    },
    validateEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    // changeNumber() {
    //   console.log(this.number0);
    // },
    // checkAll(){
    //   let index = this.select.indexOf(-1);
    //   console.log(index)
    //   // if(index != -1) this.select.splice(index, 1);
    //   if(index !== -1) {
    //     for(let i = 0; i < this.options.length; i++) {
    //       if(this.select.indexOf(this.options[i].id) === -1) {
    //         this.select.push(this.options[i].id);
    //       }
    //     }
    //   } else {
    //     this.select = [];
    //   }
    //   console.log(this.select)
    // },
    openLoadingInDiv() {
      // if(this.isFromCheckout) {
      //   this.$vs.loading({
      //     container: '#app',
      //     scale: 0.8
      //   })
      // } else {
      //   this.$vs.loading({
      //     container: '#customer-list-view',
      //     scale: 0.8
      //   })
      // }
      this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      this.isOpenLoading = true;
      setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Update customer failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Update customer failed",
            acceptText: "OK",
          });
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading() {
      // if(this.isFromCheckout) {
      //   this.$vs.loading.close('#app > .con-vs-loading');
      // } else {
      //   this.$vs.loading.close('#customer-list-view > .con-vs-loading');
      // }
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    changeFormat(day) {
      if(day) {
        return changeFormatWithDateTime(day);
      } else {
        return 'N/A';
      }
    },
    // changeFormat1(day){
    //   // return moment(day).format('DD/MM/Y');
    //   // console.log(moment(day).format('DD/MM'));
    //   return changeFormatBirthday(day);
    // },
    closePopup() {
      this.popupActive = false;
      this.$emit("ClosePopup");
      this.temp = this.customerInfo;
      // this.v_full_name = this.temp.full_name;
      this.number0 = 0;
      this.select = [];
    },
    closePopupDelete() {
      this.popupActive = false;
    },
    // getGroupString(array) {
    //   let groupString = '';
    //   for(let i = 0; i < this.array.length; i++) {
    //     if(i == 0) { groupString += this.array[0] }
    //     else {
    //       groupString = groupString + ',' + this.array[i]
    //     }
    //   }
    //   return groupString;
    // },
    saveUpdate() {
      this.getUtc();
      let valid_email = this.validateEmail(this.email);
      if (
        this.temp.full_name != "" &&
        (valid_email == true || this.email == "" || this.email == null) &&
        this.errors.first("full_name") == undefined
      ) {
        this.openLoadingInDiv();
        // let groupString = '';
        // // if(this.select.length == 0) {
        // //   for(let i = 0; i < this.selectTemp.length; i++) {
        // //     if(i == 0) { groupString += this.selectTemp[0] }
        // //     else {
        // //       groupString = groupString + ',' + this.selectTemp[i]
        // //     }
        // //   }
        // //   // groupString = this.getGroupString(this.selectTemp);
        // // } else {
        //   // groupString = this.getGroupString(this.select);
        //   for(let i = 0; i < this.select.length; i++) {
        //     if(i == 0) { groupString += this.select[0] }
        //     else {
        //       groupString = groupString + ',' + this.select[i]
        //     }
        //   }
        // // }

        const obj = {
          id: this.activeCustomer.id,
          full_name: this.temp.full_name.replace(/\s+/g, " ").trim(),
          phone: this.temp.phone,
          email: this.temp.email == null ? "" : this.temp.email,
          note: this.temp.note ? this.temp.note : "",
          visit_count: this.temp.visit_count,
          is_send_sms: this.temp.is_send_sms ? 1 : 0,
          // is_send_sms : this.temp.is_send_sms,
          // group_ids   : groupString,
          point_changed: this.number0,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          keyword: this.search,
          checkout_filter: this.checkoutFilter,
          isFromCalling: this.isFromCalling,
          is_blocked_from_booking: this.temp.is_blocked_from_booking ? 1 : 0
        };
        // console.log(obj)
        if (this.filter && this.filter.id != 1) {
          obj.type = this.filter.name;
        }
        // console.log(this.temp.group_id)
        // if(this.temp.birthday != null && this.temp.birthday.split('-')[1] != null && this.temp.birthday.split('-')[2] != null
        //   && this.temp.birthday.split('-')[1] != 'Select month' && this.temp.birthday.split('-')[2] != 'Select day') {
        //   obj.birth_day = this.temp.birthday.split('-')[2];
        //   obj.birth_month = this.temp.birthday.split('-')[1];
        // }
        if (this.birthday != null) {
          this.getUtc();
          if (this.has_change_birthday) {
            if (this.utc_birth == false) {
              this.birthday = new Date(
                this.birthday.getFullYear(),
                this.birthday.getMonth(),
                this.birthday.getDate() + 1
              );
            }
          }
          let day_arr = moment(this.birthday).format("MM/DD").split("/");
          obj.birth_day = day_arr[1];
          obj.birth_month = day_arr[0];
        }
        this.$store
          .dispatch("customerList/UPDATE_A_CUSTOMER", obj)
          .then(() => {
            this.closePopup();
            this.closeLoading();
            this.$vs.notify({
              title: "Notification",
              text: "Update Customer Success",
              color: "success",
              position: "top-right",
            });
          })
          .catch((error) => {
            console.log(error);
            if (error.email && error.email[0]) {
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: error.email[0],
                color: "danger",
                position: "top-right",
              });
            }
          });
      }
    },
    setAutoHeight(id) {
      let elem = document.getElementById(id);
      if (elem) {
        elem.style.height = "auto";
        elem.style.height = elem.scrollHeight + "px";
      }
    },
    // deleteCustomer() {
    //   const obj = {
    //     id: this.activeCustomer.id
    //   }
    //   this.$store.dispatch("customerList/DELETE_A_CUSTOMER", obj).then(() => this.closePopup())
    // },
    // getGroupList() {
    //   this.$store.dispatch("customerList/GET_GROUP_LIST").then((response) => {
    //     // console.log(response)
    //   })
    // }
  },
  computed: {
    customerInfo() {
      return this.$store.getters["customerList/customerInfo"];
    },
    // groupList() {
    //   // console.log('b')
    //   return this.$store.getters["customerList/groupList"];
    // },
    birthday: {
      get() {
        // console.log(this.date);
        return this.date;
      },
      set(value) {
        // console.log('aaa')
        // console.log(value)
        // console.log(this.changeFormat1(value));
        this.date = value;
        this.has_change_birthday = true;
        // console.log(this.date)
      },
    },
    full_name: {
      get() {
        return this.temp.full_name;
      },
      set(value) {
        this.temp.full_name = value;
      },
    },
    create_at: {
      get() {
        return this.temp.create_at;
        // return 1;
      },
      set(value) {
        this.temp.create_at = value;
      },
    },
    current_point: {
      get() {
        return this.temp.current_point;
      },
      set(value) {
        this.temp.current_point = value;
      },
    },
    visit_count: {
      get() {
        return this.temp.visit_count;
      },
      set(value) {
        this.temp.visit_count = value;
      },
    },
    lifetime_point: {
      get() {
        return this.temp.lifetime_point;
      },
      set(value) {
        this.temp.lifetime_point = value;
      },
    },
    phone: {
      get() {
        return StringHelper.phoneNumberFormat(this.temp.phone, this.halfShow);
      },
      set(value) {
        this.temp.phone = value;
      },
    },
    email: {
      get() {
        return this.temp.email;
      },
      set(value) {
        this.temp.email = value;
      },
    },
    note: {
      get() {
        if (this.temp.note) {
          return this.temp.note;
        } else {
          return "";
        }
      },
      set(value) {
        this.temp.note = value;
        this.setAutoHeight("customer_note_textarea");
      },
    },
    is_send_sms: {
      get() {
        // if(this.temp.is_send_sms == 0) return false;
        // else return true;
        return this.temp.is_send_sms;
      },
      set(value) {
        this.temp.is_send_sms = value;
        // if(value == true) {
        //   this.temp.is_send_sms = 1;
        // } else {
        //   this.temp.is_send_sms = 0;
        // }
      },
    },
    group_id: {
      get() {
        return this.temp.group_id;
      },
      set(value) {
        this.temp.group_id = value;
      },
    },
    show_option_block_booking(){
      if (typeof this.temp.is_blocked_from_booking !== 'undefined'){
        return true;
      }
      return false;
    },
    is_blocked_from_booking: {
      get() {
        return this.temp.is_blocked_from_booking;
      },
      set(value) {
        this.temp.is_blocked_from_booking = value;
      },
    },
    source() {
      if(this.temp.source) {
        return this.temp.source.charAt(0).toUpperCase() + this.temp.source.slice(1);
      }
      return null;
    }
    // month: {
    //   get() {
    //     if(this.temp.birthday == null) {
    //       return 'Select month';
    //     } else {
    //       return this.temp.birthday.split('-')[1];
    //     }
    //   },
    //   set(value) {
    //     if(this.temp.birthday == null) {
    //       this.temp.birthday = '1969-' + value + '-' + this.day;
    //       // console.log(this.day)
    //       // console.log(this.temp.birthday)
    //     } else {
    //       // console.log(this.day)
    //       // console.log(this.temp.birthday)
    //       this.temp.birthday = this.temp.birthday.split('-')[0] + '-' + value + '-' + this.temp.birthday.split('-')[2];
    //     }
    //   }
    // },
    // day: {
    //   get() {
    //     if(this.temp.birthday == null) {
    //       return 'Select day';
    //     } else {
    //       return this.temp.birthday.split('-')[2];
    //     }
    //   },
    //   set(value) {
    //     if(this.temp.birthday == null) {
    //       this.temp.birthday = '1969-' + this.month + '-' + value;
    //     } else {
    //       // console.log(this.month)
    //       // console.log(this.temp.birthday)
    //       this.temp.birthday = this.temp.birthday.split('-')[0] + '-' + this.temp.birthday.split('-')[1] + '-' + value;
    //     }
    //   }
    // }
  },

  // created() {
  //   for (let i = 1; i <= 12; i++) {
  //     this.months.push(i);
  //   }
  //   for (let i = 1; i <= 31; i++) {
  //     this.days.push(i);
  //   }
  //   // this.temp = {};
  //   // this.number0 = 0;
  //   // this.temp = JSON.parse(JSON.stringify(this.$store.getters["customerList/customerInfo"]));
  //   // console.log(JSON.parse(JSON.stringify(this.$store.getters["customerList/customerInfo"])));
  //   // this.$store.dispatch("customerList/GET_GROUP_LIST").then((response) => {
  //   //     // console.log(response)
  //   //     console.log('a');
  //   //   })
  // }
};
</script>
